import type { ReactNode } from 'react';

import { create } from 'zustand';

interface HeaderLeftSlotState {
  content: ReactNode | null;
  setContent: (content: ReactNode | null) => void;
}

export const useHeaderLeftSlotStore = create<HeaderLeftSlotState>((set) => ({
  content: null,
  setContent: (content) => set({ content }),
}));
